import styled from "styled-components";
import {
  zeeguuOrange,
  blue200,
  blue500,
  blue800,
} from "../../components/colors";

const Tag = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1rem;
  line-height: 150%;
  font-weight: 600;
  margin: 0.5rem;
  border: 1.5px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 2rem;
  padding: 0.75rem 1.5rem;
  background: none;
  cursor: pointer;

  &.outlined-orange {
    border: 1.5px solid ${zeeguuOrange};
  }

  &.small {
    padding: 0.5rem 1rem;
    margin: 0.25rem;
    font-weight: 500;
    font-size: 0.9rem;
  }

  /* Dense rows -- filter chips and the class pills on a text -- where the pill
     is metadata beside other text rather than a control of its own. */
  &.tiny,
  &.tiny.selected,
  &.tiny.outlined-orange,
  &.tiny.outlined-blue {
    padding: 0.25rem 0.6rem;
    margin: 0;
    gap: 0.25rem;
    font-weight: 500;
    font-size: 0.74rem;
    border-radius: 999px;
    border-width: 1px;
  }

  &.outlined-blue {
    align-items: center;
    border: 1.5px solid ${blue500};
    background-color: ${blue200};
    color: ${blue800};
  }

  &.selected {
    border: 1.5px solid ${zeeguuOrange};
    background-color: ${zeeguuOrange};
    color: var(--orange-btn-text);
  }

  @media (max-width: 576px) {
    font-size: 0.9rem;
    margin: 0.4rem;
    padding: 0.75rem 1rem;
  }
`;

export default Tag;
